/** Display catalog for the existing one-time create-checkout bundles. */
export const FREE_ANALYSES = 3;
export const CREDIT_PACKS = [
  { type: "refill", name: "10-Credit Pack", price: 4.99, credits: 10, description: "Buy it on its own or add to your balance." },
  { type: "starter", name: "Starter Pack", price: 9.99, credits: 25, description: "Room to work through the pattern." },
  { type: "pro", name: "Pro Pack", price: 24.99, credits: 80, description: "More clarity. Better value per credit." },
] as const;
export type CreditPackType = (typeof CREDIT_PACKS)[number]["type"];